var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr-document-editor',{attrs:{"is-saving":_vm.isSaving,"is-admin":_vm.loggedInEmployee.isAdmin},on:{"save":_vm.onSave,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }